// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"b3d3b2ec","418":"2e424655","466":"13775ce9","489":"29accfdf","538":"fdefad42","759":"9691a3cd","786":"2fa13cfd"}[chunkId] + ".chunk.js";
};